module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"courier-map-deleted":"Courier map deleted","failed-delete-courier-map":"Failed to delete courier map"}}')
  delete Component.options._Ctor
}
